import isString from 'lodash/isString';

export default (value) => {
  if (!isString(value)) return value;

  return value.replace(/\s+/g, ' ').trim();
};
